import * as api from '../_api';

export const read = async ({ commit, dispatch }, { trainingId, ceoId }) => {
  try {
    const result = await api.read(trainingId, ceoId);
    commit('setTraining', result.training);
    commit('setCompanyGuests', result.savedGuests);
    commit('setSavedGuests', result.savedGuests);
    commit('setTrainingGuests', result.trainingGuests);
    commit('setTrainingCeo', result.trainingCeo);
    commit('setCeo', result.ceo);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, { root: true });
    return false;
  }
};

export const removeGuest = async ({ commit, dispatch }, { trainingId, ceoId, guestId }) => {
  try {
    await api.removeGuest(trainingId, ceoId, guestId);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, { root: true });
    return false;
  }
};

export const addGuests = async ({ commit, dispatch }, { trainingId, ceoId, guests }) => {
  try {
    await api.addGuests(trainingId, ceoId, guests);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, { root: true });
    return false;
  }
};

export const createGuest = async ({ commit, dispatch }, { guest, training }) => {
  try {
    await api.createGuest(training.id, guest.company, guest);
    return true;
  } catch (err) {
    dispatch('common/snackbar/warning', err, { root: true });
    return false;
  }
};
